<template>
  <div class="app">
    <splitpanes class="default-theme">
      <pane size="15">
        <bd-category></bd-category>
      </pane>
      <pane size="18">
        <bd-article-list></bd-article-list>
      </pane>
      <pane size="67">
        <bd-main></bd-main>
      </pane>
    </splitpanes>
  </div>
</template>

<script>
// https://antoniandre.github.io/splitpanes/
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import BdCategory from '@/components/dashboard/main/kb/knowledge/BdCategory'
import BdArticleList from '@/components/dashboard/main/kb/knowledge/BdArticleList'
import BdMain from '@/components/dashboard/main/kb/knowledge/BdMain'

export default {
  name: 'bd-kb',
  components: { BdArticleList, BdCategory, BdMain, Splitpanes, Pane },
  data () {
    return {
    }
  }
}
</script>

<style scope>
</style>
